import React from 'react';
import { AggregatedOrganizationStatsData } from '../../../utils/organization-stats-handlers';
import CustomBarChart from '../../data-widgets/CustomBarChart';
import { useTranslation } from 'react-i18next';
import { dateToStringFormat } from '@common/utils/date';
import { DateTime } from 'luxon';

const WeeklyCleaningDurationChart: React.FC<{
  aggregatedData: AggregatedOrganizationStatsData | null;
  loading?: boolean;
  skipAnimation?: boolean;
  filterWeeks: (week: string) => boolean;
}> = ({ aggregatedData, loading, skipAnimation, filterWeeks }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <CustomBarChart
        title={t('label-weekly-cleaning-duration')}
        loading={loading}
        skipAnimation={skipAnimation}
        xAxis={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.week),
            label: t('label-week'),
            scaleType: 'band',
            valueFormatter: (date) => dateToStringFormat(DateTime.fromISO(date), true),
          },
        ]}
        series={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.duration),
          },
        ]}
        yLabel={t('label-hours-long')}
      />
    </React.Fragment>
  );
};

export default WeeklyCleaningDurationChart;
